<script setup>
import { computed } from 'vue'

const props = defineProps({
    grade: {
        type: String,
        required: true,
        validator: (value) => ['A', 'B', 'C', 'D', 'F'].includes(value)
    },
    variant: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'risk'].includes(value)
    },
    size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md', 'lg'].includes(value)
    }
})

const gradeColors = {
    default: {
        A: 'bg-emerald-100 text-emerald-700 border-emerald-300',
        B: 'bg-blue-100 text-blue-700 border-blue-300',
        C: 'bg-amber-100 text-amber-700 border-amber-300',
        D: 'bg-orange-100 text-orange-700 border-orange-300',
        F: 'bg-red-100 text-red-700 border-red-300'
    },
    risk: {
        A: 'bg-emerald-100 text-emerald-700 border-emerald-300',
        B: 'bg-blue-100 text-blue-700 border-blue-300',
        C: 'bg-amber-100 text-amber-700 border-amber-300',
        D: 'bg-orange-100 text-orange-700 border-orange-300',
        F: 'bg-red-100 text-red-700 border-red-300'
    }
}

const sizeClasses = {
    sm: 'h-7 w-7 text-sm',
    md: 'h-9 w-9 text-base',
    lg: 'h-11 w-11 text-lg'
}

const colorClass = computed(() => gradeColors[props.variant][props.grade] || gradeColors.default.C)
const sizeClass = computed(() => sizeClasses[props.size] || sizeClasses.md)
</script>

<template>
    <div
        :class="[
            'inline-flex items-center justify-center rounded-full border font-bold shrink-0',
            colorClass,
            sizeClass
        ]"
    >
        {{ grade }}
    </div>
</template>
